// frontend/src/graphql/sio.js
//
// SIO (Safari Intelligent Optimizer) — multi-recommendation endpoint.
// Returns up to six named, PricingEngine-priced itineraries.
// builderPayload maps 1:1 onto the customTourPricingPreview /
// SubmitCustomTourRequest argument set, so applying a card is a pure
// state hand-off with no re-derivation.

import { gql } from '@apollo/client';

export const RECOMMEND_ITINERARIES = gql`
  query RecommendItineraries(
    $countrySlugs:        [String!]!
    $touristComposition:  [TouristCompositionInput!]!
    $startDate:           Date!
    $endDate:             Date!
    $preferences:         SIOPreferencesInput
    $maxRecommendations:  Int
    $includePricing:      Boolean
  ) {
    recommendItineraries(
      countrySlugs:        $countrySlugs
      touristComposition:  $touristComposition
      startDate:           $startDate
      endDate:             $endDate
      preferences:         $preferences
      maxRecommendations:  $maxRecommendations
      includePricing:      $includePricing
    ) {
      category
      categoryLabel
      title
      totalDistanceKm
      isPriced
      totalPrice
      pricePerPerson
      currency
      pricingError
      categories
      nightsWithoutLodge
      priceNote
      migrationInSeason
      migrationNote
      reasons
      warnings
      scores {
        wildlife migration budget luxury family
        photography routeQuality balanced
      }
      stays {
        parkId
        parkName
        parkSlug
        parkCountrySlug
        nights
        propertyId
        propertyName
        migrationZones
        activities
      }
      days {
        dayNumber
        date
        parkId
        park
        nightOfStay
        stayNights
        isArrivalDay
        activities
        migrationZone
        accommodationId
        accommodationName
      }
      builderPayload {
        countrySlugs
        startDate
        endDate
        selectedParkIds
        selectedPropertyIds
        parkNightsJson
        migrationZonesJson
      }
    }
  }
`;